export const UMB_PROPERTY_TYPE_WORKSPACE_ALIAS = 'Umb.Workspace.PropertyType';
export const UMB_PROPERTY_TYPE_ENTITY_TYPE = 'property-type';
